import {
  AssessmentButton,
  AssessmentCheckboxRadio,
  DeleteIcon,
  InputField,
  showToast,
  SkeletonList,
} from "ui-components";
import "./Documentation.scss";
import { useEffect, useRef, useState } from "react";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { t } from "i18next";
import { CommonEnums } from "../../../utils/Enums/CommonEnums";
import FileSelectorButton from "./FileSelection";
import EditIcon from "../../../utils/Images/EditIcon";
import {
  staffAugAddSetting,
  staffAugmSettingDelete,
  staffAugSettingsDetails,
  updateStaffAugmSetting,
} from "../../../service/Settings/Settings";
import { handleDownloadEncryptFile } from "../../../utils/Common/VideoUploader";
import { getSplittedCdnUrl } from "../../../utils/Common/Constant";
import Loader from "../../../components/Loader/Loader";
import DocumentIcon from "../../../utils/Images/DocumentIcon";

const Documentation = () => {
  const [opendocumentSettingModal, setOpenDocumentSettingModal] = useState<any>(
    {
      title: "",
      isOpen: false,
    },
  );
  const [checkboxFilter, setCheckboxFilter] = useState<any>(
    CommonEnums.DOCUMENT_MANDATORY,
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [currentDocId, setCurrentDocId] = useState(0);
  const [files, setFiles] = useState<any[]>([]);
  const [fileProgressList, setFileProgressList] = useState<any[]>([]);
  const [showPopup, setShowPopup] = useState<any>(false);
  const [uploadedMasterDocs, setUploadedMasterDocs] = useState<any>([]);
  const [settingDetails, setSettingDetails] = useState<any>([]);
  const [addTitle, setAddTitle] = useState("");
  const [loading, setLoading] = useState(true);
  // Update Func
  const [editItem, setEditItem] = useState<any>(null);
  useEffect(() => {
    const isAllFilesUploaded = fileProgressList.every(
      (item) => item.status === "Completed",
    );
    if (fileProgressList.length > 0) {
      setShowPopup(true);
      if (isAllFilesUploaded) {
        setUploadedMasterDocs([...uploadedMasterDocs, ...fileProgressList]);
        setFileProgressList([]);
        setShowPopup(false);
      }
    }
  }, [fileProgressList]);

  useEffect(() => {
    getSettingsDetailsApi();
  }, []);
  const getSettingsDetailsApi = async () => {
    try {
      setLoading(true); // start loader before API call
      const res = await staffAugSettingsDetails();
      if (res?.status === 200) {
        setSettingDetails(res?.data);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false); // stop loader no matter success or error
    }
  };

  const stageMap: Record<string, string> = {
    [CommonEnums.MASTER_DOCUMENTS_TITLE]: "masterDocuments",
    [CommonEnums.VENDOR_ONBOARDING_TITLE]: "vendorOnboardingRequirements",
    [CommonEnums.RESOURCE_REQUIREMENTS_TITLE]: "resourceRequirements",
    [CommonEnums.CONTRACT_REQUIREMENTS_TITLE]: "contractRequirements",
  };
  // Save Func
  const handleSave = async () => {
    try {
      const stageKey = stageMap[opendocumentSettingModal?.title] || "";

      const payload = {
        stage: stageKey,
        oldTitle: editItem?.oldTitle, // only required in update
        stageRequirements: {
          title: addTitle,
          isMandatory: checkboxFilter === CommonEnums.DOCUMENT_MANDATORY,
        },
      };

      let res;
      if (editItem) {
        res = await updateStaffAugmSetting(payload);
      } else {
        res = await staffAugAddSetting(payload);
      }

      if (res?.status === 200) {
        showToast(res?.customMessage, "success");
        getSettingsDetailsApi();
        setAddTitle("");
        setShowPopup(false);
        setCheckboxFilter(CommonEnums.DOCUMENT_MANDATORY);
        setOpenDocumentSettingModal({ title: "", isOpen: false });
        setEditItem(null);
      }
    } catch (error) {
      console.error("Error saving:", error);
    }
  };

  // Delete Func
  const [showDelete, setShowDelete] = useState<null | {
    stage: string;
    title: string;
  }>(null);
  const handleDelete = async (stage: string, title: string) => {
    try {
      const res = await staffAugmSettingDelete(stage, title);
      if (res?.status === 200) {
        showToast(res?.customMessage, "success");
        getSettingsDetailsApi();
        setShowDelete(null);
      }
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };
  // Auto Focus in input field
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (opendocumentSettingModal && inputRef.current) {
      inputRef.current.focus();
    }
  }, [opendocumentSettingModal]);
  return (
    <div className="documentation">
      {loading ? (
        <div className="loader-overlay">
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonList
              key={`skeleton-${index}`}
              numberOfTitles={1}
              numberofTextLines={1}
              titleSize={18}
              textSize={12}
              thumbnailHeight={100}
              thumbnailWidth={100}
              itemsGap={20}
            />
          ))}
        </div>
      ) : (
        <>
          {/* Master Doc */}
          <div className="docRow row">
            <div className="col-md-8">
              <div className="docTitle">
                {t("EVENT.MASTER_DOCUMENTS_AND_TEMPLATES")}
              </div>
              <div className="requiredDoucumentsList">
                {settingDetails.masterDocuments?.map(
                  (item: any, index: number) => {
                    return (
                      <div className="row documentChip" key={index}>
                        <div className="col-md-4 documentName">
                          {downloadLoading && currentDocId === index ? (
                            <div className="d-flex gap-2">
                              <span className="pleaseWaitText">
                                {t("GENERAL.PLEASE_WAIT")}
                              </span>
                              <div className="smallLoader">
                                <Loader />
                              </div>
                            </div>
                          ) : (
                            <div
                              onClick={() => {
                                setCurrentDocId(index);
                                handleDownloadEncryptFile(
                                  getSplittedCdnUrl(item.filePath),
                                  setDownloadLoading,
                                  item?.title,
                                );
                              }}
                            >
                              <div
                                className="documentName linkStyle"
                                title={item?.title}
                              >
                                {item?.title}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 crossIcon">
                          <div
                            className="deleteSettingSec"
                            onClick={() =>
                              setShowDelete({
                                stage:
                                  stageMap[CommonEnums.MASTER_DOCUMENTS_TITLE],
                                title: item?.title,
                              })
                            }
                          >
                            <DeleteIcon />
                          </div>
                        </div>
                      </div>
                    );
                  },
                )}
              </div>
            </div>
            <div className="addButton col-md-4">
              <div className="uploadMasterDoc">
                <div>
                  <FileSelectorButton
                    files={files}
                    setFiles={setFiles}
                    fileProgressList={fileProgressList}
                    setFileProgressList={setFileProgressList}
                    isChildrenUsed={true}
                    onFilesUploaded={() => {
                      getSettingsDetailsApi();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Vendor Onboarding */}
          <div className="docRow row">
            <div className="col-md-8">
              <div className="docTitle">
                {t("EVENT.EVENT_AT_VENDOR_ONBOARDING")}
              </div>
              <div className="requiredDoucumentsList">
                {settingDetails.vendorOnboardingRequirements?.map(
                  (item: any, index: number) => {
                    return (
                      <a
                        className="row documentChip"
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="col-md-4 documentName">
                          {" "}
                          <DocumentIcon />
                          {item?.title}
                        </div>
                        <div className="col-md-4 documentName">
                          {item.isMandatory
                            ? t("SETTING.MANDATORY")
                            : t("SETTING.OPTIONAL")}
                        </div>
                        <div className="col-md-4 crossIcon">
                          <div
                            onClick={() => {
                              setEditItem({
                                stage:
                                  stageMap[CommonEnums.VENDOR_ONBOARDING_TITLE], // pass stage
                                oldTitle: item?.title,
                                isMandatory: item?.isMandatory,
                              });
                              setAddTitle(item?.title);
                              setCheckboxFilter(
                                item?.isMandatory
                                  ? CommonEnums.DOCUMENT_MANDATORY
                                  : CommonEnums.DOCUMENT_OPTIONAL,
                              );
                              setOpenDocumentSettingModal({
                                title: CommonEnums.VENDOR_ONBOARDING_TITLE,
                                isOpen: true,
                              });
                            }}
                          >
                            <EditIcon />
                          </div>

                          <div
                            className="deleteSettingSec"
                            onClick={() =>
                              setShowDelete({
                                stage:
                                  stageMap[CommonEnums.VENDOR_ONBOARDING_TITLE],
                                title: item?.title,
                              })
                            }
                          >
                            <DeleteIcon />
                          </div>
                        </div>
                      </a>
                    );
                  },
                )}
              </div>
            </div>
            <div className="addButton col-md-4">
              <AssessmentButton
                className="lightBtn docBtn"
                onClick={() =>
                  setOpenDocumentSettingModal({
                    title: CommonEnums.VENDOR_ONBOARDING_TITLE,
                    isOpen: true,
                  })
                }
              >
                {t("GENERAL.ADD")}
              </AssessmentButton>
            </div>
          </div>

          {/* Job Application */}
          <div className="docRow row">
            <div className="col-md-8">
              <div className="docTitle">
                {t("EVENT.EVENT_AT_START_OF_JOB_APPLICATION")}
              </div>
              <div className="requiredDoucumentsList">
                {settingDetails?.resourceRequirements?.map(
                  (item: any, index: number) => {
                    return (
                      <a
                        className="row documentChip"
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="col-md-4 documentName">
                          {" "}
                          <DocumentIcon />
                          {item?.title}
                        </div>
                        <div className="col-md-4 documentName">
                          {item.isMandatory
                            ? t("SETTING.MANDATORY")
                            : t("SETTING.OPTIONAL")}
                        </div>
                        <div className="col-md-4 crossIcon">
                          <div
                            onClick={() => {
                              setEditItem({
                                stage:
                                  stageMap[
                                    CommonEnums.RESOURCE_REQUIREMENTS_TITLE
                                  ],
                                oldTitle: item?.title,
                                isMandatory: item?.isMandatory,
                              });
                              setAddTitle(item?.title);
                              setCheckboxFilter(
                                item?.isMandatory
                                  ? CommonEnums.DOCUMENT_MANDATORY
                                  : CommonEnums.DOCUMENT_OPTIONAL,
                              );
                              setOpenDocumentSettingModal({
                                title: CommonEnums.RESOURCE_REQUIREMENTS_TITLE,
                                isOpen: true,
                              });
                            }}
                          >
                            <EditIcon />
                          </div>

                          <div
                            className="deleteSettingSec"
                            onClick={() =>
                              setShowDelete({
                                stage:
                                  stageMap[
                                    CommonEnums.RESOURCE_REQUIREMENTS_TITLE
                                  ],
                                title: item?.title,
                              })
                            }
                          >
                            <DeleteIcon />
                          </div>
                        </div>
                      </a>
                    );
                  },
                )}
              </div>
            </div>
            <div className="addButton col-md-4">
              <AssessmentButton
                className="lightBtn docBtn"
                onClick={() =>
                  setOpenDocumentSettingModal({
                    title: CommonEnums.RESOURCE_REQUIREMENTS_TITLE,
                    isOpen: true,
                  })
                }
              >
                {t("GENERAL.ADD")}
              </AssessmentButton>
            </div>
          </div>

          {/* Contract Creation */}
          <div className="docRow row">
            <div className="col-md-8">
              <div className="docTitle">
                {t("EVENT.EVENT_AT_START_OF_CONTRACT_CREATION")}
              </div>
              <div className="requiredDoucumentsList">
                {settingDetails?.contractRequirements?.map(
                  (item: any, index: number) => {
                    return (
                      <a
                        className="row documentChip"
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="col-md-4 documentName">
                          {" "}
                          <DocumentIcon />
                          {item?.title}
                        </div>
                        <div className="col-md-4 documentName">
                          {item.isMandatory
                            ? t("SETTING.MANDATORY")
                            : t("SETTING.OPTIONAL")}
                        </div>
                        <div className="col-md-4 crossIcon">
                          <div
                            onClick={() => {
                              setEditItem({
                                stage:
                                  stageMap[
                                    CommonEnums.CONTRACT_REQUIREMENTS_TITLE
                                  ],
                                oldTitle: item?.title,
                                isMandatory: item?.isMandatory,
                              });
                              setAddTitle(item?.title);
                              setCheckboxFilter(
                                item?.isMandatory
                                  ? CommonEnums.DOCUMENT_MANDATORY
                                  : CommonEnums.DOCUMENT_OPTIONAL,
                              );
                              setOpenDocumentSettingModal({
                                title: CommonEnums.CONTRACT_REQUIREMENTS_TITLE,
                                isOpen: true,
                              });
                            }}
                          >
                            <EditIcon />
                          </div>

                          <div
                            className="deleteSettingSec"
                            onClick={() =>
                              setShowDelete({
                                stage:
                                  stageMap[
                                    CommonEnums.CONTRACT_REQUIREMENTS_TITLE
                                  ],
                                title: item?.title,
                              })
                            }
                          >
                            <DeleteIcon />
                          </div>
                        </div>
                      </a>
                    );
                  },
                )}
              </div>
            </div>
            <div className="addButton col-md-4">
              <AssessmentButton
                className="lightBtn docBtn"
                onClick={() =>
                  setOpenDocumentSettingModal({
                    title: CommonEnums.CONTRACT_REQUIREMENTS_TITLE,
                    isOpen: true,
                  })
                }
              >
                {t("GENERAL.ADD")}
              </AssessmentButton>
            </div>
          </div>
        </>
      )}

      {/* Delete modal */}
      {showDelete && (
        <CustomModal
          show={true}
          handleClose={() => setShowDelete(null)}
          isHeaderVisible={false}
          isCrossBtn={true}
          isFooterVisible={false}
        >
          <div className="deleteIntegrationModal d-flex flex-column align-items-center">
            <h5>{t("SETTING.CONFIRM_DELETE_DOCUMENTATION")}</h5>
            <div className="d-flex gap-3 mt-3">
              <AssessmentButton
                onClick={() => handleDelete(showDelete.stage, showDelete.title)}
              >
                {t("GENERAL.YES")}
              </AssessmentButton>
              <AssessmentButton onClick={() => setShowDelete(null)}>
                {t("GENERAL.NO")}
              </AssessmentButton>
            </div>
          </div>
        </CustomModal>
      )}
      {/* Adding doc modal */}
      <CustomModal
        className="documentSettingModal"
        isCrossBtn={true}
        handleClose={() =>
          setOpenDocumentSettingModal({ data: {}, isOpen: false })
        }
        show={opendocumentSettingModal?.isOpen}
        isHeaderVisible={false}
        isFooterVisible={false}
      >
        <div className="documentSetting">
          <div className="documentSettingTitle">
            {opendocumentSettingModal?.title ===
            CommonEnums.RESOURCE_REQUIREMENTS_TITLE
              ? t("EVENT.EVENT_AT_START_OF_JOB_APPLICATION")
              : opendocumentSettingModal?.title ===
                  CommonEnums.CONTRACT_REQUIREMENTS_TITLE
                ? t("EVENT.EVENT_AT_START_OF_CONTRACT_CREATION")
                : opendocumentSettingModal?.title ===
                    CommonEnums.VENDOR_ONBOARDING_TITLE
                  ? t("EVENT.EVENT_AT_VENDOR_ONBOARDING")
                  : ""}
          </div>
          <div className="userInputSec">
            <span className="titleLabel">{t("GENERAL.TITLE")}</span>
            <div className="fields">
              <div className="input">
                <InputField
                  value={addTitle}
                  onChange={(e: any) => setAddTitle(e)}
                  placeholder={t("SETTING.TITLE_FOR_DOCUMENT")}
                  additionalProps={{
                    ref: (el: HTMLInputElement) => {
                      inputRef.current = el;
                    },
                  }}
                />
              </div>
              <div className="filterWork">
                <div
                  className="checkboxWithLabel"
                  onClick={() => {
                    setCheckboxFilter(CommonEnums.DOCUMENT_MANDATORY);
                  }}
                >
                  <AssessmentCheckboxRadio
                    type="radio"
                    checked={checkboxFilter === CommonEnums.DOCUMENT_MANDATORY}
                  />
                  <p className="radioCheckLabel">{t("SETTING.MANDATORY")}</p>
                </div>
                <div
                  className="checkboxWithLabel"
                  onClick={() => {
                    setCheckboxFilter(CommonEnums.DOCUMENT_OPTIONAL);
                  }}
                >
                  <AssessmentCheckboxRadio
                    type="radio"
                    checked={checkboxFilter === CommonEnums.DOCUMENT_OPTIONAL}
                  />
                  <p className="radioCheckLabel">{t("SETTING.OPTIONAL")}</p>
                </div>
              </div>
              <div className="saveBtn">
                <AssessmentButton onClick={handleSave}>
                  {t("GENERAL.SAVE")}
                </AssessmentButton>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
      {/* File upload modal */}
      <CustomModal
        show={showPopup}
        isCrossBtn={true}
        isHeaderVisible={false}
        handleClose={() => {
          setShowPopup(false);
          setFileProgressList([]);
          setFiles([]);
        }}
        className=""
        size="lg"
        fullscreen="md-down"
        isFooterVisible={false}
      >
        <div className="uploadCvs">
          <div className="progress-list">
            {fileProgressList.map(({ file, progress, status }) => (
              <div key={file.name} className="progress-item">
                <p>{file.name}</p>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${progress}%` }}
                  />
                  <p>
                    {progress}% {status}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default Documentation;
